import type { ReactNode } from 'react';

export const symbol_productivity: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M78-320v-94q0-35 18-63.5t50-42.5q60-26 123-43t129-17q51 0 101.5 10.5T598-541q-11 11-21 22.5T559-493q-39-14-79-20.5t-82-6.5q-60 0-117 15t-111 39q-15 7-23.5 21t-8.5 31v34h383q-1 15 0 30t3 30H78Zm320-60ZM291.5-684.5Q248-728 248-791t43.5-106.5Q335-941 398-941t106.5 43.5Q548-854 548-791t-43.5 106.5Q461-641 398-641t-106.5-43.5ZM462-727q26-26 26-64t-26-64q-26-26-64-26t-64 26q-26 26-26 64t26 64q26 26 64 26t64-26Zm-64-64Zm316.5 106.5Q671-641 608-641q-13 0-25-1t-24-6q27-29 38-66.5t11-76.5q0-39-12-76t-37-67q12-4 24-5.5t25-1.5q63 0 106.5 43.5T758-791q0 63-43.5 106.5ZM770-170q-79 0-134.5-55.5T580-360q0-79 55.5-134.5T770-550q79 0 134.5 55.5T960-360q0 79-55.5 134.5T770-170Zm-38-108 134-134-21-21-113 113-56-57-21 21 77 78Z"
		/>
	</svg>
);
